module.exports = __webpack_public_path__ + "media/images/icons/single-user-abc77f7438bdecb77cc5c9cfb4c8b00d.svg";